module.exports = __webpack_public_path__ + "img/icon-alert_triangle copy.97c92bfe.svg";